export function getKlaviyoId() {
    if (process.client) {
        const match = document.cookie.match(/__kla_id=([^;]+)/)
        return match ? match[1] : null
    }
    return null
}